import React from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
  Text,
  ModalFooter,
  HStack,
  Box,
} from "@chakra-ui/react";

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "full";
  maxWidth?: string;
  maxHeight?: string;
  isCentered?: boolean;
  motionPreset?: "slideInBottom" | "slideInRight" | "scale" | "none";
  showCloseButton?: boolean;
  overlayBg?: string;
  footer?: React.ReactNode;
  headerAction?: React.ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  size = "md",
  maxWidth="90vw",
  maxHeight = "90vh",
  isCentered = true,
  motionPreset = "scale",
  showCloseButton = true,
  overlayBg = "blackAlpha.300",
  footer,
  headerAction,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={isCentered}
      motionPreset={motionPreset}
      size={size}
    >
      <ModalOverlay bg={overlayBg} />
      <ModalContent
        m="5%"
        maxW={maxWidth || (size === "full" ? "90vw" : undefined)}
        maxH={maxHeight || (size === "full" ? "90vh" : undefined)}
        overflow="auto"
      >
        <ModalHeader>
          <Flex
            direction="row"
            justify="space-between"
            align="center"
            width="100%"
          >
            <Flex direction="column" justify="center" flex="1" p={1} minW={0}>
              {typeof title === "string" ? (
                <Text fontSize="lg" fontWeight="bold" color="black" mb={0}>
                  {title}
                </Text>
              ) : (
                <Box minW={0}>
                  {title}
                </Box>
              )}
            </Flex>
            <HStack>
              {headerAction && (
                <Flex align="center" mr={showCloseButton ? 14 : 0}>
                  {headerAction}
                </Flex>
              )}
              {showCloseButton && <ModalCloseButton  m={1}/>}
            </HStack>
          </Flex>
        </ModalHeader>
        <ModalBody overflow="auto" maxH="90vh">
          {children}
        </ModalBody>
        {footer && (
          <ModalFooter>
            {footer}
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CustomModal;